var map = {
	"./0.svg": "05f4",
	"./1.svg": "5aac",
	"./10.svg": "6f68",
	"./11.svg": "77bc",
	"./12.svg": "ceb7",
	"./13.svg": "cc03",
	"./14.svg": "9f5c",
	"./15.svg": "da35",
	"./16.svg": "a547",
	"./17.svg": "1439",
	"./2.svg": "d917",
	"./3.svg": "5595",
	"./4.svg": "fb73",
	"./5.svg": "b3d1",
	"./6.svg": "9a21",
	"./7.svg": "c055",
	"./8.svg": "f6fa",
	"./9.svg": "df97",
	"./actions.svg": "87ae",
	"./add-circle.svg": "606d",
	"./add.svg": "b3c0",
	"./arrow-down.svg": "b4c8",
	"./arrow-left.svg": "f6db",
	"./arrow-right.svg": "8281",
	"./arrow-up.svg": "4a80",
	"./bin.svg": "b143",
	"./bullet.svg": "9408",
	"./byggeri.svg": "f64c",
	"./check.svg": "4a24",
	"./checkmark.svg": "ca3f",
	"./clear.svg": "a33b",
	"./cloud-download.svg": "19e0",
	"./cloud-upload.svg": "a676",
	"./file.svg": "fe3c",
	"./flag.svg": "cc69",
	"./history.svg": "69ff",
	"./keyboard_arrow_sort.svg": "d775",
	"./logo.svg": "a5f7",
	"./niraslogo.svg": "7c46",
	"./overwrite.svg": "3a86",
	"./pdf-file.svg": "a613",
	"./pencil.svg": "be21",
	"./sdg-wheel-black.svg": "545d",
	"./sdg-wheel.svg": "b9b2",
	"./tasks/task1.svg": "469d",
	"./tasks/task10.svg": "87c5",
	"./tasks/task11.svg": "ded0",
	"./tasks/task12.svg": "6dad",
	"./tasks/task13.svg": "2610",
	"./tasks/task14.svg": "a5d1",
	"./tasks/task15.svg": "4864",
	"./tasks/task16.svg": "4ab8",
	"./tasks/task17.svg": "062f",
	"./tasks/task2.svg": "9697",
	"./tasks/task3.svg": "23c6b",
	"./tasks/task4.svg": "7cf8",
	"./tasks/task5.svg": "bb84",
	"./tasks/task6.svg": "d72e",
	"./tasks/task7.svg": "f35f",
	"./tasks/task8.svg": "1067",
	"./tasks/task9.svg": "b9de"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "4555";